<template>
    <Modal2
        id="term-of-service-modal"
        :title="$t('message.privacyPolicyAndTerms')"
        @cancel="$emit('cancel')"
        @ok="$emit('agree')"
        :okText="'I read and agree'"
        :cancelText="$t('message.cancel')"
    >
        <a-tabs :default-active-key="type">
            <a-tab-pane key="pp" :tab="$t('message.privacyPolicyTab')">
                <div class="term-of-service-modal-content">
                    <h4><b>{{ $t('message.privacyPolicyTitle') }}</b></h4>
                    {{ $t('message.privacyPolicyDescription') }}<br /><br />

                    <h4><b>{{ $t('message.informationWeCollect') }}</b></h4>
                    <b>{{ $t('message.weCollectFollowingInformation') }}</b>:<br /><br />

                    <b>{{ $t('message.customerAccountInformation') }}</b>: {{ $t('message.customerAccountData') }}<br />
                    <b>{{ $t('message.userInformation') }}</b>: {{ $t('message.userProvidedInformation') }}<br /><br />

                    <h4><b>{{ $t('message.dataDeletionProcess') }}</b></h4>
                    <b>{{ $t('message.dataDeletionProcedures') }}</b>:<br /><br />

                    <b>{{ $t('message.automaticDeletion') }}</b>: {{ $t('message.automaticDeletionInfo') }}<br />
                    <b>{{ $t('message.directRequest') }}</b>: {{ $t('message.directRequestInfo') }}<br />
                    <b>{{ $t('message.websiteVisitorDataDeletion') }}</b>: {{ $t('message.websiteVisitorDataDeletionInfo') }}<br /><br />

                    <h4><b>{{ $t('message.howToContactUs') }}</b></h4>
                    <b>{{ $t('message.contactChannels') }}</b>:<br /><br />

                    Email: m@softcand.com WhatsApp: +902162322282 Website: supsis.com or softcand.com Live Support on
                    Website: supsis.com or softcand.com<br /><br />

                    <h4><b>{{ $t('message.dataProcessingAndSharing') }}</b></h4>
                    <b>{{ $t('message.handleCustomerData') }}</b>:<br /><br />

                    <b>{{ $t('message.noThirdPartySharing') }}</b>: {{ $t('message.noThirdPartySharingInfo') }}<br />
                    <b>{{ $t('message.promotionalEmails') }}</b>: {{ $t('message.promotionalEmailsInfo') }}<br />
                    <b>{{ $t('message.visitorAndConversationData') }}</b>: {{ $t('message.noSharingVisitorData') }}<br /><br />

                    <h4><b>{{ $t('message.thirdPartyServices') }}</b></h4>

                    <h5><b>{{ $t('message.googleOAuth') }}</b></h5>
                    <br />
                    <b>{{ $t('message.googleCalendar') }}</b>: {{ $t('message.googleCalendarInfo') }}<br />
                    <b>{{ $t('message.googleAccountPublicProfile') }}</b>: {{ $t('message.googleAccountPublicProfileInfo') }}<br /><br />

                    <h4><b>{{ $t('message.changesToPrivacyPolicy') }}</b></h4>
                    <br />
                    {{ $t('message.privacyPolicyUpdateInfo') }}<br /><br />
                    {{ $t('message.privacyPolicyContactInfo') }}
                </div>
            </a-tab-pane>
            <a-tab-pane key="tac" :tab="$t('message.termsAndConditionsTab')" force-render>
                <div class="term-of-service-modal-content">
                    <br />
                    <h4>{{ $t('message.termsOfServiceTitle') }}</h4>
                    <br />
                    {{ $t('message.lastUpdated') }} 27 Haziran 2023. {{ $t('message.inEffect') }} 1 Temmuz 2023. {{ $t('message.importantTerms') }}<br />
                    {{ $t('message.termsDescription') }}<br /><br />

                    <h4>1 {{ $t('message.applicationOfTerms') }}</h4>
                    <br />
                    <ul>
                        <li>
                            {{ $t('message.termsApplyToAllUsers') }}
                        </li>
                        <li>
                            {{ $t('message.termsUpdateNotice') }}
                        </li>
                        <li>
                            {{ $t('message.termsDisagreementNotice') }}
                        </li>
                        <li>
                            {{ $t('message.consumerRightsNotice') }}
                        </li>
                    </ul>
                    <br />
                    <br />
                    <h4>2 {{ $t('message.theService') }}</h4>
                    <br />
                    <ul>
                        <li>
                            {{ $t('message.serviceGrant') }}
                        </li>
                        <li>
                            {{ $t('message.serviceAccess') }}
                        </li>
                        <li>
                            {{ $t('message.serviceAgentAppointment') }}
                        </li>
                        <li>
                            {{ $t('message.additionalAccountsAppointment') }}
                        </li>
                        <li>
                            {{ $t('message.accountControl') }}
                        </li>
                        <li>
                            {{ $t('message.serviceAffiliation') }}
                        </li>
                        <li>
                            {{ $t('message.serviceLinks') }}
                        </li>
                        <li>
                            {{ $t('message.contentMonitoring') }}
                        </li>
                        <li>
                            {{ $t('message.serviceControl') }}
                        </li>
                    </ul>
                    <br />
                    <br />
                    <h4>3 {{ $t('message.yourRightsAndObligations') }}</h4>
                    <br />
                    <ul>
                        <li>
                            {{ $t('message.contentAdditionRestriction') }}
                        </li>
                        <li>
                            {{ $t('message.restrictionsOnServiceUse') }}
                        </li>
                    </ul>
                    <br />
                    <br />
                    <h4>4 {{ $t('message.payments') }}</h4>
                    <br />
                    <b>{{ $t('message.paymentAcknowledgment') }}</b>:
                    <ul>
                        <li>
                            {{ $t('message.paymentMethodDebit') }}
                        </li>
                        <li>
                            {{ $t('message.cancellationPolicy') }}
                        </li>
                    </ul>
                    <br />
                    <br />
                    <h4>5 {{ $t('message.intellectualProperty') }}</h4>
                    <br />
                    <ul>
                        <li>
                            {{ $t('message.contentDefinition') }}
                        </li>
                        <li>
                            {{ $t('message.intellectualPropertyRightsTransfer') }}
                        </li>
                        <li>
                            {{ $t('message.userContentRights') }}
                        </li>
                        <li>
                            {{ $t('message.grantLicense') }}
                        </li>
                        <li>
                            {{ $t('message.subLicense') }}
                        </li>
                        <li>
                            {{ $t('message.moralRights') }}
                        </li>
                        <li>
                            {{ $t('message.licenseSurvival') }}
                        </li>
                        <li>
                            {{ $t('message.rightsRepresentation') }}
                        </li>
                    </ul>
                    <br />
                    <br />
                    <h4>6 {{ $t('message.warranties') }}</h4>
                    <br />
                    <b>{{ $t('message.warrantiesAcknowledgment') }}</b>:
                    <ul>
                        <li>{{ $t('message.accountOwnership') }}</li>
                        <li>{{ $t('message.serviceUsageAgreement') }}</li>
                        <li>{{ $t('message.legalCapacity') }}</li>
                    </ul>
                    <br />
                    <br />
                    <h4>7 {{ $t('message.liability') }}</h4>
                    <br />
                    <ul>
                        <li>{{ $t('message.liabilityForLoss') }}</li>
                        <li>{{ $t('message.indemnification') }}</li>
                        <li>{{ $t('message.exclusionOfLiability') }}</li>
                        <li>{{ $t('message.totalLiabilityLimit') }}</li>
                        <li>{{ $t('message.exclusionOfTerms') }}</li>
                        <li>{{ $t('message.statutoryObligations') }}</li>
                        <li>{{ $t('message.statuteProhibition') }}</li>
                    </ul>
                    <br />
                    <br />
                    <h4>8 {{ $t('message.termination') }}</h4>
                    <br />
                    <ul>
                        <li>{{ $t('message.terminationAutomatic') }}</li>
                        <li>{{ $t('message.terminationNotice') }}</li>
                        <li>{{ $t('message.cancelService') }}</li>
                        <li>{{ $t('message.terminationRights') }}</li>
                    </ul>
                    <br />
                    <br />
                    <h4>9 {{ $t('message.general') }}</h4>
                    <br />
                    <ul>
                        <li>{{ $t('message.assignmentRestriction') }}</li>
                        <li>{{ $t('message.invalidProvision') }}</li>
                        <li>{{ $t('message.expenseResponsibility') }}</li>
                        <li>{{ $t('message.governingLaw') }}</li>
                    </ul>
                </div>
            </a-tab-pane>
        </a-tabs>
    </Modal2>
</template>
<script>
import Modal2 from "./common/Modal2.vue";

export default {
    name: "TermOfService",
    components: { Modal2 },
    props: ["type"],
};
</script>
<style lang="scss">
#term-of-service-modal {
    .ant-modal {
        width: 60vw !important;
        max-height: 70vh !important;

        .term-of-service-modal-content {
            height: 50vh;
            overflow: auto;
        }
    }
}
</style>
